import { useMemo } from 'react';

import { DataTableContext, DataTableContextValue } from './DataTableContext.js';
import { DataTableRow } from './DataTableTypes.js';

export type DataTableProviderProps<
  TRow extends DataTableRow,
  TContext = unknown
> = DataTableContextValue<TRow, TContext> & {
  children?: React.ReactNode;
};

export const DataTableProvider = <TRow extends DataTableRow, TContext = unknown>({
  columns,
  rows,
  register,
  unregister,
  update,
  manager,
  context,
  children,
}: DataTableProviderProps<TRow, TContext>) => {
  const value = useMemo(
    () =>
      ({
        columns,
        rows,
        manager,
        register,
        unregister,
        update,
        context,
      } as any as DataTableContextValue),
    [columns, rows, manager, register, unregister, update, context]
  );

  return <DataTableContext.Provider value={value}>{children}</DataTableContext.Provider>;
};
